module.exports = __webpack_public_path__ + "img/scene_choose_icon.ded2104b.svg";